"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Composer = void 0;
class Composer {
    constructor(composer) {
        this.active = composer.active;
        this.altered = composer.altered;
        this.created = composer.created;
        this.description = composer.description;
        this.name = composer.name;
        this.sql_id = composer.sql_id;
        this.querySnap = composer.querySnap;
        this.documentId = composer.documentId;
        this.ref = composer.ref;
    }
    async fromCollection(collection) {
        const collectionSnapshot = await collection.get();
        return this.fromDocumentSnapshotArray(collectionSnapshot.docs);
    }
    fromDocumentSnapshot(documentSnapshot) {
        return new Composer({
            ...documentSnapshot.data(),
            querySnap: documentSnapshot,
            documentId: documentSnapshot.id,
            ref: documentSnapshot.ref
        });
    }
    fromDocumentSnapshotArray(documentSnapshot) {
        return documentSnapshot.map(document => {
            return new Composer({
                ...document.data(),
                querySnap: document,
                documentId: document.id,
                ref: document.ref
            });
        });
    }
}
exports.Composer = Composer;
//# sourceMappingURL=Composer.js.map